import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { Pagination, Navigation } from 'swiper/modules';
import "../styles/swiper.css"
import { RxDimensions } from "react-icons/rx";
import { FaLocationDot } from "react-icons/fa6";
import { useNavigate } from 'react-router-dom';
import { useTr } from '../lib/i18n';
import { detailPathLang, CITY_RU, ruPrice, ruRooms, ruSotok, ruPlural } from '../lib/ru';

const ApartmentCard = ({ listing, theme = 'white' }) => {

    const navigate = useNavigate();
    const tr = useTr();
    const lang = tr('ro', 'ru');

    const handleCardClick = () => {
        const loc = listing.listing?.location?.slug ?? listing.listing?.location?.id;
        navigate(detailPathLang(lang, 'apartamente', loc, listing.listing?.slug, listing.listing?.ru_slug));
    };

    return (
        <div className={`flex flex-col ${theme === 'white' ? 'bg-white' : 'bg-[#272727] border-[1px] text-white border-black'} shadow-lg rounded-[5px]`}>
            <div className="relative swiper-fixed-height group">
                <Swiper
                    slidesPerView={1}
                    spaceBetween={30}
                    loop={true}
                    pagination={{ clickable: true }}
                    navigation={true}
                    modules={[Pagination, Navigation]}
                    className="mySwiper h-full rounded-[5px]"
                >
                    {(listing.listing?.images ?? []).map((img, idx) => (
                    <SwiperSlide key={idx}>
                        <img
                        src={listing.listing?.thumbnails?.[idx] ?? listing.listing?.images?.[idx]}
                        alt={lang === 'ru' ? (listing.listing?.ru_seo_title || listing.listing?.seo_title) : listing.listing?.seo_title}
                        loading={idx === 0 ? 'eager' : 'lazy'}
                        fetchPriority={idx === 0 ? 'high' : 'auto'}
                        className="w-full h-full object-cover cursor-pointer"
                        onClick={handleCardClick}
                        />
                    </SwiperSlide>
                    ))}
                </Swiper>
                </div>

            <div className="flex flex-col gap-[10px] p-[10px] cursor-pointer pt-[10px]"  onClick={handleCardClick}>
                <p className='text-[16px] font-poppins font-[500] leading-[1.3] line-clamp-2'>{lang === 'ru' ? (listing.listing?.ru_seo_title || listing.listing?.seo_title) : listing.listing?.seo_title}</p>
                <p className={`text-[14px] font-body ${theme === 'white' ? 'text-gray-600' : 'text-gray-300'} leading-[1.35] line-clamp-2`}>{(lang === 'ru' ? (listing.listing?.ru_description || '') : listing.listing?.description || '').replace(/<[^>]*>/g, ' ').trim()}</p>
                <div className="flex justify-between items-center flex-wrap gap-[5px]">
                    <div className="flex gap-[5px] items-center font-body text-[14px]">
                        <RxDimensions className='text-[#d5ab63] text-lg' />
                        <p>{lang === 'ru' ? `${listing.surface} м² · ${ruRooms(listing.rooms)} · этаж ${listing.floor}` : `${listing.surface} m² · ${listing.rooms} camere · etaj ${listing.floor}`}</p>
                    </div>
                    <div className={`flex gap-[4px] items-center font-body text-[13px] ${theme === 'white' ? 'text-gray-600' : 'text-gray-300'}`}>
                        <FaLocationDot className='text-[#d5ab63]' />
                        <p>{lang === 'ru' ? (CITY_RU[listing.listing?.location?.slug]?.name || listing.listing?.location?.location) : (listing.listing?.sector?.sector || listing.listing?.location?.location)}</p>
                    </div>
                </div>

                <div className="flex gap-[3px] text-[20px] font-[500] font-poppins">
                    <p>{lang === 'ru' ? ruPrice(listing.listing?.price ?? 0) : new Intl.NumberFormat('ro-RO').format(listing.listing?.price ?? 0)}</p>
                    <p>€</p>
                </div>
            </div>

        </div>
    )
}

export default ApartmentCard